<template>
  <div class="wrapper-check-availability--item d--grid">
    <div class="wrapper-check-availability--item-left d--grid">
      <slot name="availability-left">
        <div>
          <div class="recommended-day">
            <span class="recommended-start">{{
              startDate | ladFnStrDate('DD')
            }}</span>
            <span class="recommended-start-month-year">{{
              startDate | ladFnStrDate('MMM, YYYY') | removeEndPoint
            }}</span>
          </div>
        </div>

        <div class="recommended-counter"
          ><div
            ><span>{{ days }}</span></div
          ></div
        >

        <div>
          <div class="recommended-day">
            <span class="recommended-end">{{
              endDate | ladFnStrDate('DD')
            }}</span>
            <span class="recommended-end-month-year">{{
              endDate | ladFnStrDate('MMM, YYYY') | removeEndPoint
            }}</span>
          </div>
        </div>
      </slot>
    </div>

    <div class="wrapper-check-availability--item-right">
      <div class="btn-availability-wrapper">
        <div class="title-container">
          <slot name="before-title-container" />

          <slot name="title-container">
            <div class="availability-price">
              <div>&nbsp;</div>
              <!-- eslint-disable -->
              <LadPrice
                :price="item.price"
                :currency="currency"
                :promotions="promotions"
                :show-footer="true"
                :show-header="true"
                :parent-data="priceData"
                :product="{ is_lad: exExperience.is_lad }"
              />
              <!-- eslint-enable -->
            </div>

            <p
              v-if="exExperience.is_lad"
              class="availability-liquidate-before align-right"
            >
              {{
                $tc(`${base}.liquidate_before`, item.liquidate_before, {
                  days: item.liquidate_before,
                })
              }}
            </p>

            <p
              v-if="item.description"
              class="availability-liquidate-before align-right"
              v-html="item.description"
            />

            <LadAvailabilityCharacteristics
              :item="item"
              :seasons="seasons"
              :with-separator="true"
            />
          </slot>

          <slot name="after-title-container" />
        </div>

        <div
          class="btn-container"
          :class="{ 'is-external-platform': !exExperience.is_lad }"
        >
          <template v-if="platform.name === 'Tourradar'">
            <el-button
              :loading="loadingAvailabilityByCode"
              type="text"
              class="btn--btn-layaway"
              @click="loadAvailabilityByCode"
              ><span>{{ this.$t('general.show_more') }}</span></el-button
            >
          </template>
          <template v-else-if="isFlairAirlinesSource">
            <el-button type="success" class="btn--btn-layaway" @click="scrollTo"
              ><span
                >{{ $t('shopping_cart.layaway', { amount: layawayAmount }) }}
              </span></el-button
            >
          </template>
          <template v-else>
            <div class="btn-container-column">
              <div
                class="btn-container"
                :class="{ 'is-external-platform': !exExperience.is_lad }"
              >
                <el-button
                  type="success"
                  class="btn--btn-layaway"
                  @click="goTo('fast-checkout')"
                  ><span
                    >{{
                      $t('shopping_cart.layaway', { amount: layawayAmount })
                    }}
                  </span></el-button
                >
                <el-button
                  type="text"
                  class="btn--btn-layaway"
                  @click="goTo('shopping_cart')"
                  ><span>{{ $t('shopping_cart.add') }} </span></el-button
                >
              </div>
              <div
                v-if="item.service_fee_percent"
                class="service-fees-per-person"
                >{{
                  $t(`general.service_fee_per_person`, {
                    amount: serviceFeeAmount,
                  })
                }}
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LadPriceCommonMixin from '@/components/frontends/Price/components/mixin/promo'
import LadParamsMixin from '@/utils/mixin/lad-params'

export default {
  name: 'LadAvailabilityItem',
  filters: {
    removeEndPoint: (text) => text.replace('.', ''),
  },
  components: {
    LadAvailabilityCharacteristics: () =>
      import(
        /* webpackChunkName: "lad-ava-characteristics" */ './characteristics'
      ),
  },
  mixins: [LadPriceCommonMixin, LadParamsMixin],
  props: {
    experience: { type: Object, required: true },
    platform: { type: Object, default: () => ({}), required: false },
    item: { type: Object, required: true },
  },
  data() {
    return {
      base: 'experience.availability.modal.item',
      format: 'YYYY-MM-DD',
      loadingAvailabilityByCode: false,
      delay: 1500,
    }
  },
  computed: {
    ...mapState('experience', {
      exExperience: (state) => ({
        uuid: state.experience.uuid,
        name: state.experience.name,
        type: state.experience.type,
        duration: state.experience.duration,
        starting_point: state.experience.starting_point,
        ending_point: state.experience.ending_point,
        permalink: state.experience.permalink.default,
        country: state.experience.country,
        is_lad: state.experience.is_lad,
      }),
      promotions: 'promotions',
      seasons: 'seasons',
      price: (state) => state.sales_plan.total_amount, // se usa en el mixin
    }),
    ...mapState('modals', {
      isAvailabilityModalOpen: (state) => state.availability.opened,
    }),
    ...mapState('settings', ['currency']),
    days() {
      return this.item.days === 1 ? this.item.days : `+${this.item.days}`
    },
    priceData() {
      /**
       * misma estructura del objeto en `components/frontends/Price/components/mixin/promo.js:availability`
       */
      return {
        date: this.item.datetime.start,
        language: this.item.language,
        season: this.item.season,
      }
    },
    layawayAmount() {
      return this.$options.filters.ladFnCurrency(
        this.item.layaway,
        this.currency
      )
    },
    serviceFeeAmount() {
      if (this.item.service_fee_percent) {
        return this.$options.filters.ladFnCurrency(
          (this.item.service_fee_percent / 100) * this.item.original_price,
          this.currency
        )
      }
      return 0
    },
    startDate() {
      return this.$dayjs(this.item.datetime.start, this.format)
    },
    endDate() {
      return this.$dayjs(this.item.datetime.end, this.format)
    },
    isFlairAirlinesSource() {
      return this.params.utm_source === 'flair'
    },
  },
  methods: {
    scrollTo() {
      const promise = this.isAvailabilityModalOpen
        ? this.$store.dispatch('modals/toggle', 'availability')
        : new Promise((resolve, reject) => resolve())

      promise.then(async () => {
        await this.$nuxt.$emit('close-bottom-drawer')

        this.$scrollTo('#lad-landing--form', this.delay, {
          offset: 5,
        })

        /** Sending event to Facebook */
        if (typeof this.$fb !== 'undefined') {
          this.$fb.trackCustom('click_more_info', {
            event_category: 'cta',
            event_label: `CTA with click_more_info`,
          })
        }

        /** Sending event to Google Analytics */
        if (typeof this.$gtag !== 'undefined') {
          this.$gtag('event', 'click_more_info', {
            event_category: 'cta',
            event_label: `CTA with click_more_info`,
            page_title: this.$metaInfo.title,
            page_location: window.location.href,
          })
        }
      })
    },
    goTo(type) {
      const promise = this.isAvailabilityModalOpen
        ? this.$store.dispatch('modals/toggle', 'availability')
        : new Promise((resolve, reject) => resolve())

      const data = {
        type: this.exExperience.type,
        item: {
          uuid: this.exExperience.uuid,
          qty: this.item.min_travelers || 1,
          unit: 1,
          parent: { uuid: null, index: null },
          departure_date: {
            open: !this.item.datetime.start,
            start: this.item.datetime.start,
            end: this.item.datetime.end,
            code: this.item.code,
            language: this.item.language,
            season: this.item.season,
            min_travelers: this.item.min_travelers,
            max_travelers: this.item.max_travelers,
          },
        },
      }
      promise.then(() => {
        switch (type) {
          case 'shopping_cart':
            if (process.browser) {
              const price = this.price - this.discountAmount

              // evento GA
              if (typeof this.$gtag !== 'undefined') {
                this.$gtag('event', 'add_to_cart', {
                  items: [
                    {
                      id: data.item.uuid,
                      name: this.exExperience.name,
                      list_name: 'generic',
                      brand: this.exExperience.is_lad
                        ? 'localadventures'
                        : 'third party',
                      category:
                        data.type === 'experience'
                          ? 'multi-day experience'
                          : 'product',
                      variant: '',
                      list_position: 1,
                      quantity: data.item.qty * data.item.unit,
                      price: price === 0 ? '' : price.toFixed(2).toString(),
                    },
                  ],
                  page_title: this.$metaInfo.title,
                  page_location: window.location.href,
                })

                this.$gtag('event', 'eec.addToCart', {
                  ecommerce: {
                    currencyCode: this.currency, // Currency (eg USD)
                    add: {
                      products: [
                        {
                          name: this.exExperience.name, // Product Name (eg Shirt1)
                          id: data.item.uuid, // Product ID (eg 123)
                          price: price === 0 ? '' : price.toFixed(2).toString(),
                          quantity: (data.item.qty * data.item.unit).toString(), // Product Quantity (eg 1)
                        },
                      ],
                    },
                  },
                  page_title: this.$metaInfo.title,
                  page_location: window.location.href,
                })
              }

              if (typeof this.$tiktok !== 'undefined') {
                this.$tiktok.track('AddToCart', {
                  value: price * data.item.qty * data.item.unit,
                  currency: this.currency,
                  contents: [
                    {
                      content_id: data.item.uuid,
                      content_type: data.type,
                      content_name: this.exExperience.name,
                      price,
                      quantity: data.item.qty * data.item.unit,
                    },
                  ],
                  // query: '<search_keywords>', // string. The word or phrase used to search. Example: "SAVE10COUPON".
                })
              }
            }

            this.$store.dispatch('shopping-cart/addProduct', data)
            this.$router.push({ name: 'shopping-cart' })
            break
          case 'fast-checkout':
            this.$store.dispatch('shopping-cart/setFastCheckout', data)
            this.$router.push({ name: 'checkout-layaway', params: { type } })
            break
          default:
            break
        }
      })
    },
    async loadAvailabilityByCode() {
      this.loadingAvailabilityByCode = true
      await this.$store.dispatch('availability/getAvailabilityByCode', {
        permalink: this.$route.params.permalink,
        code: this.item.code,
      })
      this.loadingAvailabilityByCode = false
    },
    handleReserve() {
      this.$emit('reserve', this.item)
    },
    toogleOpen() {
      this.$emit('open', this.item)
    },
  },
}
</script>

<style lang="scss">
.wrapper-check-availability--item {
  grid-template-columns: auto 1fr;

  .wrapper--price-with-promotions {
    .wrapper--price-top,
    .wrapper--price-bottom {
      text-align: right;
    }

    .wrapper--price-top {
      padding-top: 0;
    }

    .discount-value > span > span {
      display: none;
    }
  }

  .wrapper-status-show-flights {
    padding: 5px 15px 5px 5px;
    cursor: pointer;
  }

  &-left {
    grid-template-columns: auto 50px auto;
    align-items: center;
    padding: 10px 15px 15px;

    .recommended-day {
      display: flex;
      flex-direction: column;
      width: 70px;
      text-align: center;
    }
    .recommended-start,
    .recommended-end {
      font-size: 4em;
      font-weight: 600;
    }
    .recommended-start-month-year,
    .recommended-end-month-year {
      font-size: 0.9em;
      text-transform: capitalize;
    }
    .recommended-end,
    .recommended-end-month-year {
      text-align: right;
    }

    .recommended-counter {
      padding: 0 5px;

      span {
        background-color: #f9f9f9;
        border: 1px solid #ebeef2;
        padding: 7px;
        border-radius: 50%;
        font-size: 0.9em;
        position: relative;
        display: block;
        text-align: center;
        width: 38px;
        height: 38px;
        line-height: 21px;
        margin: 0 auto;
        z-index: 10;
      }
      div {
        position: relative;

        &::before,
        &::after {
          content: ' ';
          border-top: 1px solid #ebeef2;
          position: absolute;
          width: 100%;
          top: 50%;
          z-index: 5;
        }
      }
    }

    & > * {
      &:first-child,
      &:last-child {
        width: auto;
      }
    }

    @media screen and (max-width: 900px) {
      grid-template-columns: auto 1fr auto;
    }
  }

  &-right {
    padding: 15px;
    border-left: 1px solid #ebeef2;

    .btn-availability-wrapper {
      display: grid;
      grid-template-columns: 2fr 1fr;
      grid-gap: 15px;
    }

    .availability-separator {
      display: block;
      line-height: 2;

      &:not(.empty)::before,
      &:not(.empty)::after {
        content: ' - ';
      }
    }

    .places {
      margin-top: 8px;
      display: block;
      font-size: 0.9em;
      font-style: italic;
    }

    .availability-price {
      display: grid;
      grid-gap: 5px;
      grid-template-columns: 1fr auto;

      .price--price {
        font-size: 2em;
      }
    }

    .title-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .availability-liquidate-before {
        font-style: italic;
        text-align: right;
        font-size: 0.9em;
        margin: 0;
      }
    }

    .btn-container {
      text-align: center;

      .btn--book-now {
        padding: 0;
      }

      .btn--btn-layaway {
        width: 98%;
        margin-bottom: 10px;
        margin-left: 0;
        padding-left: 10px;
        padding-right: 10px;
        // text-transform: uppercase;
      }

      &.is-external-platform {
        display: flex;
        align-items: center;
        justify-content: center;

        .el-button {
          width: 100%;
        }
      }

      &-column {
        display: flex;
        flex-direction: column;
      }

      .service-fees-per-person {
        font-size: 0.8em;
        font-weight: bold;
        margin-bottom: 10px;
      }
    }

    @media screen and (max-width: 900px) {
      border-left: 0;
      border: 1px solid #ebeef2;
      padding: 1em 0 0 0;

      .availability-separator {
        display: none;
      }

      .availability-liquidate-before {
        font-style: normal !important;
        margin-top: 10px !important;
      }

      .align-right {
        text-align: right !important;
      }

      .align-center {
        text-align: center !important;
      }

      .btn-availability-wrapper {
        display: block;
        // grid-template-columns: 1fr;
      }

      .title-container {
        padding-right: 1em;
      }

      .btn-container {
        margin-top: 15px;
        // display: table;
        display: grid;
        grid-template-columns: repeat(2, 1fr);

        .el-button {
          border-radius: 0;
          // display: table-cell;
          // width: calc(50% - 2px);
          border: 0;

          &.btn--book-now {
            order: 2;
            border-top: 1px solid #ebeef2;
            line-height: 33px;
          }
        }
      }
    }

    @media screen and (max-width: 500px) {
      .btn-container {
        grid-template-columns: 1fr auto;

        .el-button {
          &.btn--book-now {
            font-size: 0.9em;
            padding: 0 20px;
          }
        }
      }
    }
  }

  & + .wrapper-check-availability--item {
    border-top: 1px solid #ebeef2;
  }

  &:hover {
    background-color: #f9f9f9;

    .wrapper-date-summary {
      .el-divider {
        &__text {
          background-color: #f9f9f9;
        }
      }
    }
  }

  @media screen and (max-width: 900px) {
    display: block;

    .btn--book-now {
      padding: 6px 0;
    }

    & + .wrapper-check-availability--item {
      border-top: 1em solid #ebeef2;
    }
  }
}
</style>
